import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';
import { YES_NO_ENUM_FILTER_TO_CID } from 'src/utils/constants/contentIdMaps';
import { FromYesNoEnum, ToYesNoEnum } from 'src/utils/eventQueryUtils';

type IsMappedFilter = {
  isMapped: boolean | null;
};

export const useIsMappedFilters = <TFilter extends IsMappedFilter>({
  query,
  setQuery,
  enableEmptySelection = true,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
  enableEmptySelection?: boolean;
}): FilterToolbarItem => {
  return {
    filterId: 'isMapped' as FilterToolbarItemId,
    labelContentId: ContentId.EventMapped,
    filterQueryKeys: ['isMapped'] as FilterToolbarItemId[],
    filterItem: (
      <PosEnumSelect
        style={{ width: '100%' }}
        value={ToYesNoEnum(query.isMapped)}
        placeholderText={ContentId.All}
        enableEmptySelection={enableEmptySelection}
        onChange={(yesNoEnumValue) => {
          if (yesNoEnumValue !== ToYesNoEnum(query.isMapped)) {
            setQuery({
              ...query,
              isMapped: FromYesNoEnum(yesNoEnumValue),
            });
          }
        }}
        valueOptionsContent={YES_NO_ENUM_FILTER_TO_CID}
      />
    ),
  };
};
